{
  "app.name": "AppKernia",
  "app.short_name": "AK",
  "common.actions.back": "Back",
  "common.actions.cancel": "Cancel",
  "common.actions.close": "Close",
  "common.actions.confirm": "Confirm",
  "common.actions.create": "Create",
  "common.actions.delete": "Delete",
  "common.actions.edit": "Edit",
  "common.actions.next": "Next",
  "common.actions.refresh": "Refresh",
  "common.actions.reset": "Reset",
  "common.actions.retry": "Retry",
  "common.actions.save": "Save",
  "common.actions.search": "Search",
  "common.actions.sign_out": "Sign out",
  "common.actions.submit": "Submit",
  "common.actions.view": "View",
  "common.avatar_upload.choose": "Choose image",
  "common.avatar_upload.choose_another": "Choose another",
  "common.avatar_upload.crop.area": "Avatar crop area; drag the image to adjust its position",
  "common.avatar_upload.crop.confirm": "Use this crop",
  "common.avatar_upload.crop.description": "Drag the image or use the direction buttons to position it. Adjust zoom or rotation, then confirm the crop.",
  "common.avatar_upload.crop.error": "This image could not be processed. Choose another JPEG, PNG, or WebP image.",
  "common.avatar_upload.crop.move_down": "Move image down",
  "common.avatar_upload.crop.move_left": "Move image left",
  "common.avatar_upload.crop.move_right": "Move image right",
  "common.avatar_upload.crop.move_up": "Move image up",
  "common.avatar_upload.crop.rotate_left": "Rotate 90 degrees left",
  "common.avatar_upload.crop.rotate_right": "Rotate 90 degrees right",
  "common.avatar_upload.crop.title": "Crop avatar",
  "common.avatar_upload.crop.zoom": "Zoom",
  "common.avatar_upload.crop_again": "Crop again",
  "common.avatar_upload.description": "Choose a JPEG, PNG, or WebP image, crop it in your browser, then upload it securely. The source image is not saved in browser storage.",
  "common.avatar_upload.invalid": "Choose a JPEG, PNG, or WebP image up to 5 MB.",
  "common.avatar_upload.progress": "Avatar upload progress: {percent}%",
  "common.avatar_upload.ready": "A {size} × {size} pixel avatar preview is ready. Review it before uploading.",
  "common.avatar_upload.success": "Your avatar has been updated.",
  "common.avatar_upload.title": "Profile avatar",
  "common.avatar_upload.upload": "Upload avatar",
  "common.avatar_upload.upload_error": "Avatar upload failed. Your crop is preserved so you can retry.",
  "common.language.en-US": "English",
  "common.language.zh-CN": "简体中文",
  "common.localized_form.language_has_errors": "This language has fields that need attention",
  "common.localized_form.languages": "Localized content",
  "common.localized_form.load_error": "The system language list could not be loaded. Try again.",
  "common.localized_form.loading": "Loading languages…",
  "common.locales.en-US": "English (US)",
  "common.locales.zh-CN": "Simplified Chinese",
  "common.not_available": "Not available",
  "common.states.disabled": "Disabled",
  "common.states.empty": "No data",
  "common.states.enabled": "Enabled",
  "common.states.error": "Failed to load",
  "common.states.forbidden": "Access denied",
  "common.states.loading": "Loading…",
  "common.states.offline": "You are offline",
  "common.states.success": "Completed successfully",
  "meta.locale_name": "English",
  "common.field_help": "Show help for {name}",
  "common.user_picker.title": "Select {label}",
  "common.user_picker.placeholder": "Select people",
  "common.user_picker.search": "Search by name, username or email",
  "common.user_picker.name": "Name",
  "common.user_picker.username": "Username",
  "common.user_picker.email": "Email",
  "common.user_picker.status": "Status",
  "common.user_picker.statuses.all": "All statuses",
  "common.user_picker.statuses.pending": "Pending",
  "common.user_picker.statuses.active": "Active",
  "common.user_picker.statuses.disabled": "Disabled",
  "common.user_picker.statuses.locked": "Locked",
  "common.user_picker.selected": "{count} selected, maximum {max}",
  "common.user_picker.empty": "No matching people",
  "common.user_picker.load_error": "Could not load people. Please retry.",
  "common.user_picker.unavailable": "User information unavailable",
  "common.user_picker.no_permission": "User read permission is required to select people",
  "common.user_picker.clear": "Clear {label}",
  "common.user_picker.separator": ", ",
  "common.record_picker.record": "Record",
  "common.record_picker.unavailable": "Unavailable record",
  "common.record_picker.retained": "Existing association retained. The record is unavailable or access is denied. Select a replacement.",
  "common.record_picker.placeholder": "Select {label}",
  "common.record_picker.search": "Search name, identifier or keyword",
  "common.record_picker.selected": "{count} selected, up to {max}",
  "common.record_picker.name": "Name",
  "common.record_picker.identifier": "Identifier",
  "common.record_picker.details": "Details",
  "common.markdown.format": "Body format",
  "common.markdown.plain": "Plain text",
  "common.markdown.markdown": "Markdown",
  "common.markdown.copy": "Copy source",
  "common.markdown.public_image_required": "Select a public image that has passed scanning.",
  "common.markdown.image": "Insert image from file library",
  "common.markdown.fullscreen": "Edit in fullscreen",
  "common.markdown.exit_fullscreen": "Exit fullscreen",
  "common.money.yuan": "CNY",
  "common.money.invalid": "Enter an amount within the allowed range, with up to two decimal places.",
  "common.json.format": "Format JSON",
  "common.json.invalid": "Invalid JSON syntax",
  "common.credentials.hide": "Hide contents",
  "common.credentials.show": "Show contents",
  "common.credentials.pem_hint": "Paste the complete PEM, including BEGIN / END lines and line breaks. Leave blank to retain existing credentials.",
  "common.credentials.pem_invalid": "Incomplete PEM. Check the matching markers and line breaks.",
  "common.markdown.command.bold": "Bold",
  "common.markdown.command.italic": "Italic",
  "common.markdown.command.strikethrough": "Strikethrough",
  "common.markdown.command.hr": "Horizontal rule",
  "common.markdown.command.title": "Heading",
  "common.markdown.command.link": "Link",
  "common.markdown.command.quote": "Quote",
  "common.markdown.command.code": "Inline code",
  "common.markdown.command.codeBlock": "Code block",
  "common.markdown.command.table": "Table",
  "common.markdown.command.unordered-list": "Bulleted list",
  "common.markdown.command.ordered-list": "Numbered list",
  "common.markdown.command.checked-list": "Task list",
  "common.markdown.command.preview": "Preview",
  "common.markdown.command.edit": "Edit",
  "common.markdown.command.live": "Edit and preview",
  "common.markdown.command.title1": "Heading 1",
  "common.markdown.command.title2": "Heading 2",
  "common.markdown.command.title3": "Heading 3",
  "common.markdown.command.title4": "Heading 4",
  "common.markdown.command.title5": "Heading 5",
  "common.markdown.command.title6": "Heading 6"
}
